import actions from './slide-plugin.actions'
import getters from './slide-plugin.getters'

export default {
  namespaced: true,
  actions,
  getters,
}
